import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { Eye } from "mdi-material-ui";
import PropTypes from "prop-types";
function CalendarCell(props) {
    const { disabled = false, isToday = false, date, schedule, mediaName, mediaOptionName, showPopper } = props;
    const divRef = useRef(null);
    const openPopper = () => {
        if (divRef.current)
            showPopper(divRef.current, schedule);
    };
    return (_jsxs(Box, Object.assign({ sx: { opacity: disabled ? 0.5 : 1, borderWidth: "1.5px", borderStyle: "solid", borderColor: "border.light", height: "revert", padding: "10px 15px 10px 10px", width: "112px" } }, { children: [_jsxs(Stack, Object.assign({ direction: "row-reverse", justifyContent: "space-between", mb: 2 }, { children: [_jsx(Typography, Object.assign({ variant: "h2" }, { children: date.getDate() })), isToday && (_jsx(Typography, Object.assign({ variant: "h5" }, { children: "Today" })))] })), schedule &&
                _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", gap: 1, sx: { backgroundColor: "brand.light", borderRadius: "8px", padding: "3px 3px", marginTop: "6px", cursor: "pointer", overflow: "hidden" }, ref: divRef, onClick: openPopper }, { children: [_jsx(Eye, { color: "primary", sx: { fontSize: "14px" } }), _jsx(Tooltip, Object.assign({ title: `${mediaOptionName} on ${mediaName}`, placement: "right" }, { children: _jsxs(Typography, Object.assign({ variant: "h6", color: "primary", noWrap: true }, { children: [schedule.units, " ", mediaOptionName, " on ", mediaName] })) }))] }))] })));
}
CalendarCell.propTypes = {
    date: PropTypes.instanceOf(Date),
    disabled: PropTypes.bool,
    isToday: PropTypes.bool,
    schedule: PropTypes.object,
    mediaName: PropTypes.string,
    mediaOptionName: PropTypes.string,
    showPopper: PropTypes.func
};
export default CalendarCell;
